import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheLtr = createCache({
  key: 'muiltr',
  // stylisPlugins: [prefixer, {}],
  nonce: 'B4Q2OFhkN2EtMmRkYi00MTExLWFhM2YtNDhkNTc4NGJhMjA9',
});

function RTLHandler(props) {
  const { children } = props;

  return <CacheProvider value={cacheLtr}>{children}</CacheProvider>;
}

RTLHandler.propTypes = {
  children: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  locale: state.locale.locale,
});

export default connect(mapStateToProps)(RTLHandler);
